<template>
  <div class="product">
    <banner :img="bannerImg" :title="'产品中心'" titleEng="Product" />
    <!-- <div class="product-content">
      <p class="c-title animate__animated animate__fadeInLeft">产品中心</p>
      <p class="e-Title animate__animated animate__fadeInLeft">Product</p>
      <el-tabs v-model="activeTab" style="margin: 30px 0;">
        <el-tab-pane label="全部" name="3"></el-tab-pane>
        <el-tab-pane label="信息安全系统" name="4"></el-tab-pane>
        <el-tab-pane label="智能化系统" name="5"></el-tab-pane>
      </el-tabs>
      <div class="product-list">
        <div v-for="(item, i) in productList" :id="`case${i}`" :key="item.id" class="prod-item animate__animated" @click="$router.push({ name: 'newsdetails', params: { id: item.id }})">
          <div class="img-box">
            <img :src="item.coverImg" alt="">
          </div>
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div> -->
    <div class="content-wrap">
      <div class="pull-left">
        <div :class="['nav', navIndex === 1 ?  'active' : '']" @click="selectNav(1)">
          <strong>视频播放</strong>
          <span></span>
        </div>
        <div :class="['nav', navIndex === 2 ?  'active' : '']" @click="selectNav(2)">
          <strong>模式的不同</strong>
          <span></span>
        </div>
        <div :class="['nav', navIndex === 3 ?  'active' : '']" @click="selectNav(3)">
          <strong>平台目标</strong>
          <span></span>
        </div>
        <div :class="['nav', navIndex === 4 ?  'active' : '']" @click="selectNav(4)">
          <strong>功能模块</strong>
          <span></span>
        </div>
      </div>
      <div class="product-content" v-loading="false">
        <div class="p-video" id="video">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
        <div class="lacking" id="lacking">
          <h3 class="title">传统管理模式不足</h3>
          <div class="lacking-bottom">
            <div class="lacking-bottom-item animate__animated">
              <div class="lacking-bottom-item-img">
                <img src="../assets/img/product-group-icon_3.png" alt />
              </div>
              <p>质量检查、安全检查以抽查为主，难免存在遗漏，留下质量安全隐患。</p>
            </div>
  
            <div class="lacking-bottom-item animate__animated">
              <div class="lacking-bottom-item-img">
                <img src="../assets/img/product-group-icon_2.png" alt />
              </div>
              <p>数据统计、数据分析的缺失，无法为统计、分析、项目评估等工作提供数据支撑。</p>
            </div>
  
            <div class="lacking-bottom-item animate__animated">
              <div class="lacking-bottom-item-img">
                <img src="../assets/img/product-group-icon_1.png" alt />
              </div>
              <p>检查工作和检查记录文件脱节，无法做到同步对应；缺少影像文档，无法做到可追溯性。</p>
            </div>
          </div>
        </div>
        <div class="target animate__animated" id="target">
          <h3 class="title animate__animated">平台目标</h3>
          <p class="eTitle">TARGET</p>
          <div class="target-img">
            <img src="../assets/img/product_group_3_img.png" alt />
          </div>
        </div>
        <div class="modular" id="module">
          <h3 class="title">功能模块</h3>
          <p class="eTitle">MODULAR</p>
          <div class="modular-content">
            <div class="modular-content-same">
              <div class="same-item animate__animated">
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_1.png" alt />
                </div>
                <p>质量控制模块</p>
              </div>
              <div class="same-item animate__animated">
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_2.png" alt />
                </div>
                <p>知识仓库模块</p>
              </div>
              <div class="same-item animate__animated">
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_3.png" alt />
                </div>
                <p>信息流程模块</p>
              </div>
              <div class="same-item animate__animated">
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_1.png" alt />
                </div>
                <p>定位复核模块</p>
              </div>
            </div>
            <div class="modular-content-center">
              <img src="../assets/img/product_group_4_img.png" alt />
            </div>
            <div class="modular-content-same">
              <div class="same-item animate__animated">
                <p>信息处理模块</p>
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_5.png" alt />
                </div>
              </div>
              <div class="same-item animate__animated">
                <p>材料设备模块</p>
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_6.png" alt />
                </div>
              </div>
              <div class="same-item animate__animated">
                <p>进度控制模块</p>
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_7.png" alt />
                </div>
              </div>
              <div class="same-item animate__animated">
                <p>安全管理模块</p>
                <div class="same-item-img">
                  <img src="../assets/img/product-group_4-icon_8.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleByCateId, getWebsiteConfigList } from '../api';
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      videoSrc: "",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "" //url地址
          }
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        },
      },
      showModule: false,
      productList: [],
      activeTab: '3',
      navIndex: 1,
      bannerImg: ''
    };
  },
  watch: {
    // activeTab(val) {
    //   this.getList(val)
    // }
  },
  created() {
    this.getList('3')
    getWebsiteConfigList().then(res => {
      this.bannerImg = res.data.some(item => item.code === 'bg_banner_product') ? res.data.find(item => item.code === 'bg_banner_product').title : ''
    })

    // this.$http
    //   .get(
    //     "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
    //   )
    //   .then(response => {
    //     this.videoSrc = response.data[0].Content;
    //     window.console.log(this.videoSrc);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  },
  mounted() {
    // window.addEventListener('scroll', (e) => {
    //   if (window.scrollY > 1950) {
    //     // this.showModule = true
    //     // const sameItem = document.getElementsByClassName('same-item')
    //     // console.log(sameItem.length)
    //     for (let i = 0;i < 8;i++) {
    //       document.getElementsByClassName('same-item')[i].classList.add('animate__animated',i > 3 ?'animate__fadeInLeft' : 'animate__fadeInRight')
    //     }
    //     // sameItem.forEach(item => {
    //     //   item.classList.add('animate__animated','animate__fadeInLeft')
    //     // });
    //   }
    // })
    this.$nextTick(() => {

      window.addEventListener('scroll', this.scrollTop)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollTop)
  },
  methods: {
    getList(val) {
      //3全部,
      getArticleByCateId({
        cateId: val
      }).then(res => {
        // this.productList = res.data.reverse()
        const videoSrc = res.data.find(item => item.vedio).vedio
        this.playerOptions.sources[0].src = videoSrc
        this.$nextTick(() => {
          this.scrollTop()
        })
      })
    },
    scrollTop() {
      const list = ['lacking','target', 'module']
      list.forEach((item,i) => {
        const rect = document.getElementById(`${item}`).getBoundingClientRect()
        const notShow = rect.top >=
            (window.innerHeight || document.documentElement.clientHeight) ||
          rect.bottom <= 0
        if (!notShow) {
          if (i === 0) {
            for (let k = 0;k<document.getElementsByClassName(`lacking-bottom-item`).length;k++) {
              document.getElementsByClassName(`lacking-bottom-item`)[k].classList.add( k == 0 ? 'animate__fadeInTopLeft' : k==1 ? 'animate__fadeInDown' : 'animate__fadeInTopRight')
            }
          }
          if (i === 1) {
            document.getElementById('target').classList.add('animate__zoomIn')
          }
          if (i ===2 ) {
            for (let k = 0;k<document.getElementsByClassName(`same-item`).length;k++) {
              document.getElementsByClassName(`same-item`)[k].classList.add( k < 4 ? 'animate__fadeInLeft' : 'animate__fadeInRight')
            }
          }
        }
      })
    },
    selectNav(i) {
      this.navIndex = i
      const arr = ['video','lacking','target','module']
      // let scrollDis = document.documentElement.scrollTop || document.body.scrollTop
      // scrollDis = 200
      // console.dir(document.getElementsByClassName('el-container')[0])
      document.getElementById(arr[i - 1]).scrollIntoView()
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  background-color: #14679f;
}
.content-wrap {
  display: flex;
  align-items: stretch;
  // padding-left: 180px;
  background-color: #fff;
  width: 1440px;
  margin: 0 auto;
  .pull-left {
    // height: 100%;
    width: 230px;
    position: relative;
    overflow: hidden;
    margin-left: 50px;
    &::before {
      content: "";
      height: 100%;
      position: absolute;
      width: 2px;
      background: #1667a0;
      right: 10px;
      top: 0;
      }
    .nav {
      position: relative;
      text-align: right;
      margin: 30px 0;
      cursor: pointer;
      font-size: 16px;
      strong {
        position: absolute;
        right: 36px;
        // transition: right .4s;
        display: inline-block;
      }
      span {
        width: 20px;
        height: 20px;
        display: inline-block;
        border: 2px solid #1667a0;
        background: #ecf6fd;
        border-radius: 50%;
        color: #333;
        margin-left: 10px;
        transition: background .4s;
      }
    }
    .active {
      height: 45px;
      strong {
        padding: 12px 0;
        width: 200px;
        color: #fff;
        background: #1667a0;
        text-align: center;
        position: absolute;
        right: 55px;
        box-sizing: border-box;
        padding-left: 32px;
        &::before {
          content: "";
          position: absolute;
          right: -18px;
          top: 0;
          width: 0;
          height: 0;
          border-top: 22.5px solid transparent;
          border-left: 19px solid #1667a0;
          border-bottom: 22.5px solid transparent;
        }
      }
      span {
        background: #1667a0!important;
        margin-top: 12px;
      }
    }
  }
}
.product-content {
  // width: 1240px;
  margin: 0 100px;
  background-color: #fff;
  padding-bottom: 20px;
  padding-top: 40px;
  .c-title {
    font-size: 25px;
    color: #3e466b;
    font-weight: 500;
  }
  .e-Title {
    font-size: 16px;
    color: #3e466b;
    padding: 8px 0;
    font-weight: 400;
    // width: 100px;
    // text-align: center;
  }
  .product-list {
    display: flex;
    flex-wrap: wrap;
    .prod-item {
      margin: 20px 10px 0 0;
      padding-bottom: 20px;
      cursor: pointer;
      position: relative;
      &::after {
        content: '';
        width: 0;
        height: 1px;
        background: #1891ff;
        position: absolute;
        left: 0;
        bottom: 0;
        transition: all .4s;
      }
      .img-box {
        overflow: hidden;
        width: 391px;
        height: 312px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 66%;
          height: auto;
          // transform: scale(1.1);
          transition: all 0.5s;
        }
      }
      .title {
        font-size: 16px;
        margin-top: 24px;
      }
      &:hover {
        &::after {
          // border-bottom: 1px solid #1891ff;
          width: 100%;
        }
        img {
          transform: scale(1.1);
          // transition: all 0.5s;
        }
        .title {
          color: #1891ff;
        }
      }
    }
  }
}

.p-video {
  height: 600px;
  width: 1000px;
  margin: 0 auto;
  padding: 60px 0;
}

//传统管理模式不足
.lacking {
  height: 420px;
  padding: 20px 0;
  //margin: 20px 0;

  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    padding: 100px 100px;

    .lacking-bottom-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      //justify-content: center;

      .lacking-bottom-item-img {
        width: 120px;
        height: 120px;
        background: #1667a0;
        border-radius: 50%;
        overflow: hidden;
        line-height: 160px;
      }
    }
    p {
      font-size: 16px;
      text-align: start;
      margin: 10px 0;
    }
  }
}

//平台目标
.target {
  margin-top: 50px;
  &-img {
    margin-top: 50px;
    text-align: center;
  }
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 30px;
  padding: 10px 0;
}

@media screen and (max-width: 997px) {
  .content-wrap {
    width: 100%;
    .pull-left {
      // transform: scale(0.5);
      // transform-origin: left top;
      width: 120px;
      font-size: 12px;
      margin-left: 10px;
      .nav {
        font-size: 12px;
      }
      .active strong {
        right: 47px;
        padding-left: 85px;
        width: 158px;
      }
    }
  }
  .product-content {
    width: calc(100% - 170px);
    margin: 0 10px;
    .product-list {
      .prod-item {
        .img-box {
          width: 350px;
          height: 250px;
        }
      }
    }
    .p-video {
      width: 200px;
      overflow-x: auto;
      height: 180px;
    }
    .lacking {
      height: auto;
    }
    .lacking-bottom {
      padding: 10px;
      flex-wrap: wrap;
      .lacking-bottom-item {
        width: 200px;
        flex-shrink: 0;
        .lacking-bottom-item-img {
          width: 60px;
          height: 60px;
          line-height: 100px;
          img {
            width: 40px;
          }
        }
      }
    }
    .target-img img{
      width: 200px;
    }
    .modular-content {
      padding: 0;
      &-center {
        width: 150px;
      }
    }
    .modular-content-same {
      .same-item {
        flex-shrink: 0;
        p {
          font-size: 12px;
          line-height: 24px;
        }
        .same-item-img {
          width: 40px;
          height: 40px;
          line-height: 60px;
          flex-shrink: 0;
          img {
            width: 26px;
          }
        }
      }
    }
  }
}
</style>